import { type FC } from 'react'
import { NavLink } from 'react-router-dom'
import classNames from 'classnames'
import buttonStyles from '../Button/Button.module.scss'
import { MEETING_NOT_AVAILABLE_LABEL } from './model'

const MAX_TITLE_LENGTH = 20
const TRUNCATED_TITLE_LENGTH = 17

interface ConsentMeetingCellProps {
  roomId?: string
  sessionId?: string
  title?: string
  titlesLoaded: boolean
}

export const ConsentMeetingCell: FC<ConsentMeetingCellProps> = ({ roomId, sessionId, title, titlesLoaded }) => {
  if (!roomId || !sessionId) {
    return <span>-</span>
  }
  if (!title) {
    return titlesLoaded ? <span className='zocks-text-gray-600 text-nowrap'>{MEETING_NOT_AVAILABLE_LABEL}</span> : null
  }
  const displayTitle = title.length > MAX_TITLE_LENGTH ? `${title.substring(0, TRUNCATED_TITLE_LENGTH)}...` : title
  return (
    <NavLink
      className={classNames(buttonStyles.button, buttonStyles.primaryLinkButton, 'text-decoration-underline text-nowrap p-0')}
      to={`/workspace/past-meetings/room/${roomId}/session/${sessionId}`}
      title={title}
    >
      {displayTitle}
    </NavLink>
  )
}
